"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateInitialState = {};
exports.TemplateActions = {
    Open: "@ReduxTemplate/template/OPEN",
    Close: "@ReduxTemplate/template/CLOSE"
};


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Template/TemplateConstants.ts
// module id = 477
// module chunks = 0 1 2